import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/employeeSchedule'

const employeeSchedule = axios.create({
  baseURL
})

interceptorsSetup(employeeSchedule)

export default class EmployeeSchedule {
  static async getTable (scheduleQuery) {
    const result = await employeeSchedule.get('/' + scheduleQuery.siteId, {
      params:
      {
        start: scheduleQuery.start,
        end: scheduleQuery.end
      }
    })
    return result.data
  }
  static async createSchedule (schedule) {
    const result = await employeeSchedule.post('/', schedule)
    return result.data
  }
  static async updateSchedule (schedule) {
    const result = await employeeSchedule.post('/update', schedule)
    return result.data
  }
  static async archiveSchedule (schedule) {
    const result = await employeeSchedule.put('/archive/' + schedule)
    return result.data
  }
  // Archives each { id (employee), date, shift? } then inserts the rows, in one
  // transaction: a day is never left half replaced.
  static async replaceSchedules ({ siteId, archives, inserts }) {
    const result = await employeeSchedule.post('/replace', { siteId, archives, inserts })
    return result.data
  }
}
